import { ApexOptions } from 'apexcharts';

import { TFunction } from 'i18next';

interface ChartData {
  labels: string[];
  series: number[];
}

export const piePeriodsChartOptions = (chartData: ChartData, t: TFunction, isRat: boolean) => {
  const totalSum = chartData.series.reduce((acc, val) => acc + val, 0);
  const baseColors = [
    '#3366FF',
    '#299EFF',
    '#29E8FF',
    '#29FFEF',
    '#f2fa14',
    '#FFF529',
    '#FFE529',
    '#FFCE29',
    '#FFA429',
    '#FF8429',
    '#4929FF',
    '#293CFF',
  ];
  const dynamicColors = baseColors.map((color, index) => {
    const value = chartData.series[index];
    return value > 0 ? color : 'rgba(211, 211, 211, 0.4)';
  });
  const legendTextColors = baseColors.map((_, index) => {
    const value = chartData.series[index];
    return value > 0 ? '#000000' : 'rgba(211, 211, 211, 0.7)';
  });
  const chartOptions: ApexOptions = {
    chart: {
      type: 'donut',
    },
    title: {
      text: t('MCTDetail.double_pies.title_2'),
      align: 'center',
      offsetY: -3,
      style: {
        fontSize: '16px',
        fontWeight: 'bold',
        color: '#000000',
        fontFamily: 'Poppins, sans-serif',
      },
    },
    colors: dynamicColors,
    series: chartData.series || [],
    labels: chartData.labels || [],
    plotOptions: {
      pie: {
        donut: {
          size: '45%',
          labels: {
            show: false,
          },
        },
      },
    },

    tooltip: {
      enabled: true,
      fillSeriesColor: false,
      custom: ({ series, seriesIndex }: any) => {
        if (seriesIndex >= 0 && seriesIndex < chartData.labels.length) {
          const label = chartData.labels[seriesIndex];
          const value = series[seriesIndex];
          return `<div class="custom-tooltip">
            <div style="background: #ffffff; color: #333; padding: 8px 12px; border-radius: 6px; font-size: 12px; border: 2px solid ${dynamicColors[seriesIndex]};">
              ${label}: ${value} ${value === 1 ? t('MCTDetail.double_pies.mouse') : t('MCTDetail.double_pies.mice')}
            </div>
          </div>`;
        }
      },
    },
    dataLabels: {
      enabled: true,
      formatter: (_val: any, opts: any) => {
        const seriesIndex = opts.seriesIndex;

        if (seriesIndex < 0 || seriesIndex >= chartData.series.length) {
          return '';
        }

        const count = chartData.series[seriesIndex];
        const timePeriod = chartData.labels[seriesIndex];

        if (typeof count === 'number' && timePeriod) {
          const percentage = (count / totalSum) * 100;
          if (percentage >= 5) {
            return [
              String(timePeriod),
              `${count} ${count === 1 ? (isRat ? t('MCTDetail.double_pies.rat') : t('MCTDetail.double_pies.mouse')) : isRat ? t('MCTDetail.double_pies.rats') : t('MCTDetail.double_pies.mice')}`,
            ];
          }
        }

        return '';
      },
      style: {
        fontSize: '12px',
        fontWeight: 'bold',
      },
      dropShadow: {
        enabled: true,
        color: '#111',
        top: 0,
        left: 0,
        blur: 3,
        opacity: 0.7,
      },
    },
    legend: {
      fontSize: '10px',
      position: 'right',
      offsetY: 35,
      formatter: (seriesName: string, opts: any) => {
        return `<span style="color: ${legendTextColors[opts.seriesIndex]} !important;">${seriesName}</span>`;
      },
      itemMargin: {
        horizontal: 5,
        vertical: 2,
      },
      markers: {
        size: 8,
      },
      onItemClick: {
        toggleDataSeries: false,
      },
    },
    fill: {
      type: 'gradient',
    },
    responsive: [
      {
        breakpoint: 636,
        options: {
          dataLabels: {
            enabled: false,
          },
          plotOptions: {
            pie: {
              donut: {
                labels: {
                  show: false,
                },
              },
            },
          },
        },
      },
    ],
  };

  return chartOptions;
};
